export enum EllipseName {
  None = 'none',
  Conf95 = '95% confidence',
  Conf85 = '85% confidence',
  Conf50 = '50% confidence',
  Conf99 = '99% confidence',
}

// fewer than this number of shots will be rendered as neutral, otherwise accent color indicates "enough" data
export const MIN_ON_DEMAND_SHOTS = 3;

// the max number of on-demand shot IDs to store on the TMS record
export const MAX_ON_DEMAND_SHOTS = 31;
